<template>
    <div
        v-if="flows && flows.length > 0"
        class="my-3 rounded-md border-l-4 border-yellow-400 bg-yellow-50 p-4"
        role="alert"
    >
        <div class="flex">
            <div class="shrink-0">
                <svg
                    class="h-5 w-5 text-yellow-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                >
                    <path
                        fill-rule="evenodd"
                        d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 6a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 6zm0 9a1 1 0 100-2 1 1 0 000 2z"
                        clip-rule="evenodd"
                    />
                </svg>
            </div>
            <div class="ml-3 flex-1">
                <h3 class="text-sm font-semibold text-yellow-800">
                    Este usuário tem
                    {{ flows.length }}
                    fluxo{{ flows.length > 1 ? "s" : "" }} preso{{
                        flows.length > 1 ? "s" : ""
                    }}
                    na IdWall
                </h3>
                <p class="mt-1 text-sm text-yellow-700">
                    Os fluxos abaixo estão aguardando ação manual na IdWall.
                    Enquanto não forem resolvidos, novos fluxos para este perfil
                    podem não disparar.
                </p>
                <ul class="mt-3 space-y-2">
                    <li
                        v-for="flow in flows"
                        :key="flow.profile_flow_id"
                        class="rounded border border-yellow-200 bg-white p-3 text-sm"
                    >
                        <div class="flex items-start justify-between gap-2">
                            <div class="flex-1">
                                <div class="font-semibold text-gray-900">
                                    {{ flow.flow_name || "Fluxo sem nome" }}
                                </div>
                                <div class="mt-1 text-xs text-gray-600">
                                    Status:
                                    <span class="font-mono">{{
                                        flow.status
                                    }}</span>
                                </div>
                                <div
                                    v-if="flow.updated_at"
                                    class="text-xs text-gray-500"
                                >
                                    Atualizado em
                                    {{ formatDate(flow.updated_at) }}
                                </div>
                                <div
                                    v-if="flow.pendency_message"
                                    class="mt-2 text-xs text-gray-700"
                                >
                                    <strong>Motivo:</strong>
                                    {{ flow.pendency_message }}
                                </div>
                            </div>
                            <a
                                v-if="flow.profile_ref"
                                :href="buildIdwallUrl(flow.profile_ref)"
                                target="_blank"
                                rel="noopener noreferrer"
                                class="whitespace-nowrap text-xs font-medium text-indigo-600 hover:underline"
                            >
                                Abrir na IdWall
                            </a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "IdwallPendingFlowsAlert",
    props: {
        flows: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        formatDate(value) {
            if (!value) return "";
            try {
                return new Date(value).toLocaleString("pt-BR");
            } catch (e) {
                return value;
            }
        },
        buildIdwallUrl(profileRef) {
            return `https://app.idwall.co/profile/?id=${profileRef}`;
        },
    },
};
</script>
